import i18n from '@/i18n';

import type { AigcTagGroup } from '.';

export const AIGC_TAG_GROUPS: AigcTagGroup[] = [
  {
    key: 'designStyle',
    labelKey: 'data-center:ops.aigc.tag.designStyle',
    options: [
      {
        get label() {
          return i18n.t('data-center:ops.option.photorealistic.photography');
        },
        value: 'photorealistic.photography',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.illustration.design');
        },
        value: 'illustration.design',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.e.commerce.design');
        },
        value: 'e.commerce.design',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.anime');
        },
        value: 'anime',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.3d');
        },
        value: '3d',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.hand.drawn');
        },
        value: 'hand.drawn',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.flat.and.abstract');
        },
        value: 'flat.and.abstract',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.other.styles');
        },
        value: 'other.styles',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.architectural.design');
        },
        value: 'architectural.design',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.classic.painting');
        },
        value: 'classic.painting',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.cg.fantasy');
        },
        value: 'cg.fantasy',
      },
    ],
  },
  {
    key: 'modelFunction',
    labelKey: 'data-center:ops.aigc.tag.modelFunction',
    options: [
      {
        get label() {
          return i18n.t('data-center:ops.option.person.enhancement');
        },
        value: 'person.enhancement',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.art.style.enhancement');
        },
        value: 'art.style.enhancement',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.other.functions');
        },
        value: 'other.functions',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.composition.control');
        },
        value: 'composition.control',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.subject.enhancement');
        },
        value: 'subject.enhancement',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.character.enhancement');
        },
        value: 'character.enhancement',
      },
    ],
  },
  {
    key: 'contentElement',
    labelKey: 'data-center:ops.aigc.tag.contentElement',
    options: [
      {
        get label() {
          return i18n.t('data-center:ops.option.logo.and.icon');
        },
        value: 'logo.and.icon',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.merchandise');
        },
        value: 'merchandise',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.toys.and.figurines');
        },
        value: 'toys.and.figurines',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.landscapes');
        },
        value: 'landscapes',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.animals');
        },
        value: 'animals',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.crafts');
        },
        value: 'crafts',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.buildings');
        },
        value: 'buildings',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.male');
        },
        value: 'male',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.food');
        },
        value: 'food',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.female');
        },
        value: 'female',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.vehicles.and.transportation');
        },
        value: 'vehicles.and.transportation',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.sci.fi.mecha');
        },
        value: 'sci.fi.mecha',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.clothing');
        },
        value: 'clothing',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.plants');
        },
        value: 'plants',
      },
    ],
  },
];
